import React from 'react';
import classes from './StarsCell.module.css';

const StarsCell = ({ value }) => {

    const formatted = Number(value)?.toLocaleString('he-IL');

  return (
    <div className={classes.starsCell}>
      <span className={classes.starIcon}>⭐</span>
      <span className={classes.starsNumber} style={{ color: '#FFFFFF' }}>
        {formatted}
      </span>
    </div>
  );
};

export default StarsCell;
